export default [
  '$http',
  '$uibModalInstance',
  '$httpParamSerializerJQLike',
  'title',
  'description',
  'source',
  'email',
  function ($http, $uibModalInstance, $httpParamSerializerJQLike, title, description, source, email) {
  this.title = title;
  this.description = description;
  this.email = email;

  this.submit = () => {
    if (this.form.$valid) {
      this.isLoading = true;
      const params = {
        source,
        email: this.email,
        text: this.message,
        url: window.location.href,
        ua: window.navigator.userAgent,
        width: window.innerWidth,
        height: window.innerHeight,
      };
      const paramsString = Object.keys(params).map(
        // Кодируем, т.к. сервер принимает ; за разделитель параметров
        key => `${key}=${encodeURIComponent(params[key])}`
      ).join('&');
      $http.post('/ajax/feedback/', paramsString, {
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}
      }).then(data => {
        if (data.data.status === 'ok') {
          Notifications.add({
            type: 'success',
            content: 'Спасибо за ваш отзыв!',
            timeout: 10000
          });
          $uibModalInstance.close();
        } else {
          Notifications.add({
            type: 'error',
            content: 'Произошла ошибка при отправлении. Попробуйте, пожалуйста, еще раз',
            timeout: 10000
          })
        }
      }).catch(() => {
        Notifications.add({
          type: 'error',
          content: 'Произошла ошибка при отправлении. Попробуйте, пожалуйста, еще раз',
          timeout: 10000
        });
      }).finally(() => this.isLoading = false);
    }
  };
}]



// WEBPACK FOOTER //
// ./src/common/feedback/modal.ctrl.js